import * as actionTypes from "../ActionTypes";
import API from "../../network/redAPI";

export const minusHour = (d, hrs) => {
	d = new Date(d);
	return d?.setHours(d?.getHours() - hrs);
};

export const getActivePromotionCampaign = (dispatch) => {
	API.GetActiveSaleCampaign()
		.then((response) => response.json())
		.then((data) => {
			if (data.success) {
				dispatch({
					type: actionTypes.Get_Active_Promotion_Campaign,
					payload: data.data,
					success: true,
				});
			} else {
				dispatch({
					type: actionTypes.Get_Active_Promotion_Campaign,
					payload: {},
					success: false,
				});
			}
		});
};

export const checkShowCampaignBanner = (dispatch) => {
	dispatch({
		type: actionTypes.Check_Show_Promotion_Campaign,
	});
};

export const resetActivePromotionCampaign = (dispatch) => {
	dispatch({
		type: actionTypes.Reset_Active_Promotion_Campaign,
		payload: null,
		success: true,
	});
};

export const getAllProductsSaleCampaign = (body, dispatch) => {
	dispatch({
		type: actionTypes.Loading_Enable,
	});
	API.GetAllProductsSaleCampaign(body)
		.then((response) => response.json())
		.then((data) => {
			if (data.success) {
				dispatch({
					type: actionTypes.Products_Campaign,
					payload: data,
				});
				dispatch({
					type: actionTypes.Loading_Disable,
				});
			} else {
				// window.location.href = "/";
			}
		});
};

export const changeCampaignProductPage = (body, dispatch) => {
	dispatch({
		type: actionTypes.Change_Products_Campaign_Page,
		payload: body.page,
	});
};

export const resetCampaignProductPage = (dispatch) => {
	dispatch({
		type: actionTypes.Reset_Products_Campaign_Page,
	});
};
